module.exports = __webpack_public_path__ + "static/media/warning.797d8b0a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/warning.svg
// module id = 954
// module chunks = 0